import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

const SIDE_SLOT_SIZE = 40;

type Props = {
	title: string;
	subtitle?: string;
	startComponent?: ReactNode;
	endComponent?: ReactNode;
};

export const MyPlannTopBarRedesign: FC<Props> = ({
	title,
	subtitle,
	startComponent,
	endComponent,
}) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			width="100%"
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
			bgcolor={theme.palette.background.paper}
		>
			<Stack
				width={SIDE_SLOT_SIZE}
				height={SIDE_SLOT_SIZE}
				flexShrink={0}
				alignItems="flex-start"
				justifyContent="center"
			>
				{startComponent}
			</Stack>

			<Stack flex={1} minWidth={0} alignItems="center">
				<Typography variant="h3" maxWidth="100%" noWrap>
					{title}
				</Typography>
				{subtitle && (
					<Typography variant="caption" color={theme.palette.grey[500]} noWrap>
						{subtitle}
					</Typography>
				)}
			</Stack>

			<Stack
				width={SIDE_SLOT_SIZE}
				height={SIDE_SLOT_SIZE}
				flexShrink={0}
				alignItems="flex-end"
				justifyContent="center"
			>
				{endComponent}
			</Stack>
		</Stack>
	);
};
